module.exports = __webpack_public_path__ + "img/RS_changeDetection-3.241e9fdd.png";